import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";

// store/app/sagas.ts filters exactly one half of each pair out of the model for the whole session
// — today the activity PERSON / PEOPLE pair, per the multiContactActivities add-on.
const mutuallyExclusiveFeatures = [
  FieldFeature.SINGLE_CONTACT_ONLY,
  FieldFeature.MULTI_CONTACT_ONLY,
];

/**
 * Resolves a stored integration mapping to the field name representing it right now: the field's
 * own name, or — when the stored field is the filtered-out half of a mutually exclusive pair —
 * its live counterpart's name. Undefined when the name matches no field at all.
 *
 * Without the counterpart step, a mapping stored under the opposite add-on state renders as
 * unmapped and is cleared on the next save.
 *
 * The model is a parameter rather than a getByEntityType lookup: that import cycles through
 * ActivityFieldModel and silently yields an undefined model.
 */
const getFieldNameByIntegrationName = (
  fieldModel: IFieldModel,
  storedName: string
): string | undefined => {
  const field = fieldModel.getByIntegrationName(storedName);
  if (field) {
    return field.name;
  }

  const hiddenField = fieldModel.allFields.find(({ name }) => name === storedName);
  const hiddenFeature = mutuallyExclusiveFeatures.find((feature) =>
    hiddenField?.hasFeature(feature)
  );
  if (!hiddenFeature) {
    return undefined;
  }

  return fieldModel.fields.find(
    (liveField) =>
      liveField.hasAnyFeature(...mutuallyExclusiveFeatures) && !liveField.hasFeature(hiddenFeature)
  )?.name;
};

export default getFieldNameByIntegrationName;
